import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/search/",
        name: "search",
        component: () => import("@/views/pages/search/Search.vue"),
      },
      {
        path: "/notification-alert/",
        name: "notification-alert",
        component: () =>
          import("@/views/pages/notificationAlert/NotificationAlert.vue"),
      },
      {
        path: "/irb/application/new-id/:id",
        name: "new-application-id",
        component: () => import("@/views/pages/application/Application.vue"),
      },
      {
        path: "/irb/application/application-options",
        name: "application-options",
        component: () =>
          import("@/views/pages/application/ApplicationOptions.vue"),
      },
      {
        path: "/irb/application/notification-options",
        name: "notification-options",
        component: () =>
          import("@/views/pages/application/NotificationOptions.vue"),
      },
      {
        path: "/irb/application/new/",
        name: "new-application",
        component: () => import("@/views/pages/application/Application.vue"),
      },
      {
        path: "/irb/application/list",
        name: "applications",
        component: () => import("@/views/pages/application/List.vue"),
      },
      {
        path: "/irb/application/submitted",
        name: "applications-submitted",
        component: () => import("@/views/pages/application/Submitted.vue"),
      },
      {
        path: "/irb/application/collaborative",
        name: "applications-collaborative",
        component: () => import("@/views/pages/application/Collaborative.vue"),
      },
      {
        path: "/irb/application/view/:id",
        name: "application-view",
        component: () => import("@/views/pages/application/view/View.vue"),
        children: [
          {
            path: "overview",
            name: "view-overview",
            component: () =>
              import("@/views/pages/application/view/tabs/Overview.vue"),
          },
          {
            path: "faculty",
            name: "view-faculty",
            component: () =>
              import("@/views/pages/application/view/tabs/Faculty.vue"),
          },
          {
            path: "allreview",
            name: "allreview",
            component: () =>
              import("@/views/pages/application/view/tabs/AllReview.vue"),
          },
          {
            path: "research",
            name: "view-research-study",
            component: () =>
              import("@/views/pages/application/view/tabs/Research.vue"),
          },
          {
            path: "researchActivities",
            name: "view-research-activities",
            component: () =>
              import(
                "@/views/pages/application/view/tabs/ResearchActivities.vue"
              ),
          },
          {
            path: "subject",
            name: "view-subject-define",
            component: () =>
              import("@/views/pages/application/view/tabs/Subject.vue"),
          },
          {
            path: "risk",
            name: "view-risk-factor",
            component: () =>
              import("@/views/pages/application/view/tabs/Risk.vue"),
          },
          {
            path: "recruitment",
            name: "view-recruitment-factor",
            component: () =>
              import("@/views/pages/application/view/tabs/Recruitment.vue"),
          },
          {
            path: "informed",
            name: "view-informed-consent",
            component: () =>
              import("@/views/pages/application/view/tabs/Informed.vue"),
          },
          {
            path: "data",
            name: "view-data-handling",
            component: () =>
              import("@/views/pages/application/view/tabs/DataHandling.vue"),
          },
          {
            path: "document",
            name: "view-document",
            component: () =>
              import("@/views/pages/application/view/tabs/Document.vue"),
          },
          {
            path: "review",
            name: "view-review",
            component: () =>
              import("@/views/pages/application/view/tabs/Review.vue"),
          },
        ],
      },
      {
        path: "/irb/application/edit/:id",
        name: "application-edit",
        component: () => import("@/views/pages/application/Edit.vue"),
        children: [
          {
            path: "overview",
            name: "edit-overview",
            component: () =>
              import("@/views/pages/application/overview/Overview.vue"),
          },
          {
            path: "faculty",
            name: "edit-faculty",
            component: () =>
              import("@/views/pages/application/faculty/Faculty.vue"),
          },
          {
            path: "allreview",
            name: "allreview",
            component: () =>
              import("@/views/pages/application/view/tabs/AllReview.vue"),
          },
          {
            path: "research",
            name: "edit-research-study",
            component: () =>
              import("@/views/pages/application/research/Research.vue"),
          },
          {
            path: "researchActivities",
            name: "edit-research-activities",
            component: () =>
              import(
                "@/views/pages/application/researchActivities/ResearchActivities.vue"
              ),
          },
          {
            path: "subject",
            name: "edit-subject-define",
            component: () =>
              import("@/views/pages/application/subject/Subject.vue"),
          },
          {
            path: "risk",
            name: "edit-risk-factor",
            component: () => import("@/views/pages/application/risk/Risk.vue"),
          },
          {
            path: "recruitment",
            name: "edit-recruitment-factor",
            component: () =>
              import("@/views/pages/application/recruitment/Recruitment.vue"),
          },
          {
            path: "informed",
            name: "edit-informed-consent",
            component: () =>
              import("@/views/pages/application/informed/Informed.vue"),
          },
          {
            path: "data",
            name: "edit-data-handling",
            component: () =>
              import("@/views/pages/application/data/DataHandling.vue"),
          },
          {
            path: "document",
            name: "edit-document",
            component: () =>
              import("@/views/pages/application/document/Document.vue"),
          },
        ],
      },
      {
        path: "/irb/approval-letter",
        name: "approval-letter",
        component: () => import("@/views/pages/application/ApprovalLetter.vue"),
      },
      {
        path: "/irb/notification/new",
        name: "new-notification",
        component: () => import("@/views/pages/notification/FormNew.vue"),
      },
      {
        path: "/irb/notification/new/form/:id",
        name: "new-notification-form",
        component: () => import("@/views/pages/notification/SubmitForm.vue"),
      },
      {
        path: "/irb/notification/edit/form/:id",
        name: "edit-notification-form",
        component: () =>
          import("@/views/pages/notification/SubmitFormEdit.vue"),
      },
      {
        path: "/irb/notification/view/form/:id",
        name: "view-notification-form",
        component: () =>
          import("@/views/pages/notification/SubmitFormView.vue"),
      },
      {
        path: "/irb/notification/list",
        name: "notifications",
        component: () => import("@/views/pages/notification/FormList.vue"),
      },
      {
        path: "/faculty/sponsor",
        name: "faculty-sponsor",
        component: () => import("@/views/pages/faculty/SponsorApproval.vue"),
      },
      {
        path: "/member/assigned",
        name: "member-assigned",
        component: () =>
          import("@/views/pages/member/AssignedApplications.vue"),
      },
      {
        path: "/member/standard",
        name: "member-standard-app",
        component: () =>
          import("@/views/pages/member/StandardApplications.vue"),
      },
      {
        path: "/member/notifications",
        name: "member-irb-notifications",
        component: () =>
          import("@/views/pages/member/NotificationFormList.vue"),
      },
      {
        path: "/chair/apps",
        name: "chair-irb-applications",
        component: () => import("@/views/pages/chair/IrbApplications.vue"),
      },
      {
        path: "/chair/apps-expedited",
        name: "chair-irb-expedited-applications",
        component: () => import("@/views/pages/chair/IrbApplicationsUExp.vue"),
      },
      {
        path: "/chair/notifications",
        name: "chair-irb-notifications",
        component: () => import("@/views/pages/chair/NotificationFormList.vue"),
      },
      {
        path: "/chair/transaction-logs",
        name: "chair-irb-transactions-logs",
        component: () => import("@/views/pages/chair/TransactionLogsList.vue"),
      },
      {
        path: "/admin/users/list",
        name: "admin-users-list",
        component: () => import("@/views/pages/admin/users/List.vue"),
      },
      {
        path: "/admin/users/pending",
        name: "admin-pending-users-list",
        component: () => import("@/views/pages/admin/users/PendingList.vue"),
      },
      {
        path: "/admin/users/user-options",
        name: "user-options",
        component: () => import("@/views/pages/application/UserOptions.vue"),
      },
      {
        path: "/admin/issues/list",
        name: "issues-list",
        component: () => import("@/views/pages/admin/issues/IssuesList.vue"),
      },
      {
        path: "/irb/issues/view/:id",
        name: "issues-view",
        component: () => import("@/views/pages/admin/issues/IssuesView.vue"),
      },
      {
        path: "/irb/issues/edit/:id",
        name: "issues-edit",
        component: () => import("@/views/pages/admin/issues/IssuesEdit.vue"),
      },
      {
        path: "/irb/issues/create",
        name: "issues-create",
        component: () => import("@/views/pages/admin/issues/IssuesCreate.vue"),
      },
      {
        path: "/builder",
        name: "builder",
        component: () => import("@/views/Builder.vue"),
      },
      {
        path: "/pages/profile",
        name: "profile",
        component: () => import("@/views/pages/Profile.vue"),
        children: [
          {
            path: "overview",
            name: "profile-overview",
            component: () => import("@/views/pages/profile/Overview.vue"),
          },
          {
            path: "projects",
            name: "profile-projects",
            component: () => import("@/views/pages/profile/Projects.vue"),
          },
          {
            path: "campaigns",
            name: "profile-campaigns",
            component: () => import("@/views/pages/profile/Campaigns.vue"),
          },
          {
            path: "documents",
            name: "profile-documents",
            component: () => import("@/views/pages/profile/Documents.vue"),
          },
          {
            path: "connections",
            name: "profile-connections",
            component: () => import("@/views/pages/profile/Connections.vue"),
          },
          {
            path: "activity",
            name: "profile-activity",
            component: () => import("@/views/pages/profile/Activity.vue"),
          },
        ],
      },
      {
        path: "/pages/wizards/horizontal",
        name: "horizontal-wizard",
        component: () => import("@/views/pages/wizards/Horizontal.vue"),
      },
      {
        path: "/pages/wizards/vertical",
        name: "vertical-wizard",
        component: () => import("@/views/pages/wizards/Vertical.vue"),
      },
      {
        path: "/account",
        name: "account",
        component: () => import("@/views/account/Account.vue"),
        children: [
          {
            path: "overview",
            name: "account-overview",
            component: () => import("@/views/account/Overview.vue"),
          },
          {
            path: "settings",
            name: "account-settings",
            component: () => import("@/views/account/Settings.vue"),
          },
        ],
      },
      {
        path: "/apps/chat/private-chat",
        name: "apps-private-chat",
        component: () => import("@/views/chat/Chat.vue"),
      },
      {
        path: "/apps/chat/group-chat",
        name: "apps-group-chat",
        component: () => import("@/views/chat/Chat.vue"),
      },
      {
        path: "/apps/chat/drawer-chat",
        name: "apps-drawer-chat",
        component: () => import("@/views/chat/DrawerChat.vue"),
      },
      {
        path: "/modals/general/invite-friends",
        name: "modals-general-invite-friends",
        component: () => import("@/views/modals/general/InviteFriends.vue"),
      },
      {
        path: "/modals/general/view-user",
        name: "modals-general-view-user",
        component: () => import("@/views/modals/general/ViewUsers.vue"),
      },
      {
        path: "/modals/general/upgrade-plan",
        name: "modals-general-upgrade-plan",
        component: () => import("@/views/modals/general/UpgradePlan.vue"),
      },
      {
        path: "/modals/general/share-and-earn",
        name: "modals-general-share-and-earn",
        component: () => import("@/views/modals/general/ShareAndEarn.vue"),
      },
      {
        path: "/modals/forms/new-target",
        name: "modals-forms-new-target",
        component: () => import("@/views/modals/forms/NewTarget.vue"),
      },
      {
        path: "/modals/forms/new-card",
        name: "modals-forms-new-card",
        component: () => import("@/views/modals/forms/NewCard.vue"),
      },
      {
        path: "/modals/forms/new-address",
        name: "modals-forms-new-address",
        component: () => import("@/views/modals/forms/NewAddress.vue"),
      },
      {
        path: "/modals/forms/create-api-key",
        name: "modals-forms-create-api-key",
        component: () => import("@/views/modals/forms/CreateApiKey.vue"),
      },
      {
        path: "/modals/wizards/two-factor-auth",
        name: "modals-wizards-two-factor-auth",
        component: () => import("@/views/modals/wizards/TwoFactorAuth.vue"),
      },
      {
        path: "/modals/wizards/create-app",
        name: "modals-wizards-create-app",
        component: () => import("@/views/modals/wizards/CreateApp.vue"),
      },
      {
        path: "/modals/wizards/create-account",
        name: "modals-wizards-create-account",
        component: () => import("@/views/modals/wizards/CreateAccount.vue"),
      },
      {
        path: "/widgets/lists",
        name: "widgets-list",
        component: () => import("@/views/widgets/Lists.vue"),
      },
      {
        path: "/widgets/statistics",
        name: "widgets-statistics",
        component: () => import("@/views/widgets/Statistics.vue"),
      },
      {
        path: "/widgets/charts",
        name: "widgets-charts",
        component: () => import("@/views/widgets/Charts.vue"),
      },
      {
        path: "/widgets/mixed",
        name: "widgets-mixed",
        component: () => import("@/views/widgets/Mixed.vue"),
      },
      {
        path: "/widgets/tables",
        name: "widgets-tables",
        component: () => import("@/views/widgets/Tables.vue"),
      },
      {
        path: "/widgets/feeds",
        name: "widgets-feeds",
        component: () => import("@/views/widgets/Feeds.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/views/auth/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () => import("@/views/auth/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () => import("@/views/auth/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () => import("@/views/auth/PasswordReset.vue"),
      },
      {
        path: "/login-contact",
        name: "login-contact",
        component: () => import("@/views/Contact.vue"),
      },
    ],
  },
  {
    path: "/home",
    component: () => import("@/views/home/home.vue"),
  },
  {
    path: "/home-qa",
    component: () => import("@/views/home/homeqa.vue"),
  },
  {
    path: "/home-faq",
    component: () => import("@/views/home/faq.vue"),
  },
  {
    path: "/home-about",
    component: () => import("@/views/home/about.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/error/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/error/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    // A frequently asked questions
    path: "/FAQ",
    name: "FAQ",
    component: () => import("@/views/FAQ.vue"),
  },
  {
    // Inquire
    path: "/contact",
    name: "contact",
    component: () => import("@/views/Contact.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  store.dispatch(Actions.VERIFY_AUTH);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
